export const USERTIMELIST_SEARCH = 'USERTIMELIST_SEARCH';
export const USERTIMELIST_PAGE = 'USERTIMELIST_PAGE';
export const USERTIMELIST_WEEK = 'USERTIMELIST_WEEK';
export const USERTIMELIST_YEAR = 'USERTIMELIST_YEAR';
